import { Injectable, Pipe, PipeTransform } from '@angular/core';
@Injectable({
  // Make the pipe injectable as a service
  providedIn: 'root' // This makes the pipe available application-wide
})
@Pipe({
  name: 'phonenumber'
})
export class PhonenumberPipe implements PipeTransform {
  transform(value: unknown, mode: 'format' | 'unformat' = 'format'): unknown {
    if (!value) {
      return value;
    }

    if (mode === 'format') {
      if (!value) {
        return '';
      }

      // Remove any non-digit characters
      let cleaned = ('' + value).replace(/\D/g, '');

      // Prepend +1 to US numbers if not already there
      if (!cleaned.startsWith('1')) {
        cleaned = '1' + cleaned;
      }
      // Prepend +1 to US numbers if not already there
      let formatted = '';
      if (cleaned.startsWith('1')) {
        formatted = cleaned; // Already starts with +1
      } else {
        formatted = '1' + cleaned; // Prepend +1
      }

      // Format the phone number as +1 (XXX) XXX-XXXX
      const match = formatted.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
      }
    } else if (mode === 'unformat') {
      // Unformat the phone number (remove any non-digit characters)
      return value.toString().replace(/\D/g, ''); // Remove all non-digit characters
    }

    return value; // Return original if the mode is not recognized
  }
}
